import React, { useState, useEffect, useCallback } from "react"; // Added useCallback
import { useNavigate, useLocation } from "react-router-dom";
import SearchComponent from "../components/SearchComponent";
import { useGlobalState } from "../contexts/GlobalStateContext";
import Explore from "../components/Explore";
import Notifications from "../components/Notifications";
import LoginButton from "../components/LoginButton";
import Post from "../components/Post";
import { handleImageError } from "../Helpers/cookieUtils";
import { useWebSocketListener } from "../components/WebSocketService";

function Header() {
  const {
    globalState,
    setShowLogins,
    setGoTo,
    setShowExplore,
    setShowNotifications,
    setDuplicatePost,
    setNotificationCount
  } = useGlobalState();

  const location = useLocation();
  const navigate = useNavigate();

  const [isMounted, setIsMounted] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const pageName = location.pathname.split("/")[1] || "recent";
  const [lastPageName, setLastPageName] = useState(pageName);

  useEffect(() => {
    const applyTabStyle = () => {
      document.querySelectorAll(".maintablink").forEach((tab) => {
        tab.style.borderBottom = "none";
      });

      const newTab = document.getElementById(`${pageName}_button`);
      if (newTab) {
        newTab.style.borderBottom = "solid medium #3DDC84";
      }
    };

    // Wait for DOM to be painted
    const raf = requestAnimationFrame(applyTabStyle);

    // Cleanup
    return () => cancelAnimationFrame(raf);
  }, [pageName]);

  // Separate effect for handling route changes
  useEffect(() => {
    if (pageName !== lastPageName) {
      setShowCategories(false);
      setLastPageName(pageName);
    }
  }, [pageName, lastPageName]);

  // Avoid flash on first render
  useEffect(() => {
    const timer = setTimeout(() => setIsMounted(true), 0);
    return () => clearTimeout(timer);
  }, []);

  const profileImageSrc = globalState?.user?.user_id
    ? `/profile_pics_icons/${globalState.user.user_id}.jpg`
    : "/profile_pics_icons/default.jpg";


  // In Header.jsx
  const { updateNotificationCount } = useGlobalState(); // Get the fetch function

  const handleWebSocketMessage = useCallback((data) => {
    const incrementTypes = ['new_message', 'new_like', 'new_comment', 'new_follow'];

    if (incrementTypes.includes(data.type)) {
      // 1. Immediate UI Feedback (The +1)
      setNotificationCount(prev => prev + 1);

      // 2. Delayed Sync (Wait 2 seconds for DB to catch up)
      setTimeout(() => {
        updateNotificationCount();
      }, 2000);
    }
  }, [setNotificationCount, updateNotificationCount]);

  // Subscribe to the WebSocket
  useWebSocketListener(handleWebSocketMessage);


  if (!isMounted) return null;


  return (
    <>
      <Explore />
      {globalState.showNotifications && (
        <Notifications onClose={() => setShowNotifications(false)} />
      )}
      <div id="nav">
       

        <div id="messages" onClick={() => setShowExplore(true)}>
          <svg
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
              <path
                d="M 11.4124,16.292783 H 18.41166"
                style={{
                  fill: "#333",
                  stroke: "#333",
                  strokeWidth: 2,
                  strokeLinecap: "round",
                }}
              />
              <path
                d="m 6.4124,12.110025 h 18.41166"
                style={{
                  fill: "#333",
                  stroke: "#333",
                  strokeWidth: 2,
                  strokeLinecap: "round",
                }}
              />
              <path
                d="m 6.4124,7.9272666 h 18.41166"
                style={{
                  fill: "#333",
                  stroke: "#333",
                  strokeWidth: 2,
                  strokeLinecap: "round",
                }}
              />
            </g>
          </svg>
        </div>

        <div id="logo">
          <img
            height="50px"
            src="/logo.png"
            alt="Logo"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
         
        </div>

        {globalState.isAuthenticated ? (
          <>
            <img
              id="notifications-icon"
              src="/icon/notification_icon.png"
              height="22"
              width="22"
              alt="Notifications"
              onClick={() => setShowNotifications(true)}
              style={{ cursor: 'pointer' }}
            />
            {/* Use a clear conditional render instead of style={{display}} */}
            {globalState.notificationCount > 0 && (
              <span
                className="notification-count"
                id="notificationCount"
                onClick={() => setShowNotifications(true)}
              >
                {globalState.notificationCount}
              </span>
            )}
          </>
        ) : (
          <LoginButton />
        )}

        <div id="menu">
          <div className="scrollmenu">
            <button
              className="maintablink"
              id="profile_button"
              onClick={() => {
                if (globalState?.user?.username) {
                  const targetPath = `/@${globalState.user.username}`;

                  // Navigate only if not already on the exact profile path
                  if (location.pathname !== targetPath) {
                    navigate(targetPath);
                  }
                } else {
                  setShowLogins(true);
                  setGoTo("profile");
                }
              }}
            >
              <img
                className="profile_icon"
                id="profile_icon"
                src={profileImageSrc}
                height="25px"
                width="25px"
                alt="Profile"
                onError={handleImageError}
              />
            </button>

            <button
              className="maintablink"
              id="following_button"
              onClick={() => {
                if (globalState?.user?.username) {
                  navigate(`/following`);
                } else {
                  setShowLogins(true);
                  setGoTo("following");
                }
              }}
            >
              FOLLOWING
            </button>
            <button
              className="maintablink"
              id="recent_button"
              onClick={() => navigate("/")}
            >
              RECENT
            </button>
            <button
              className="maintablink"
              id="popular_button"
              onClick={() => navigate("/popular")}
            >
              POPULAR
            </button>

            <SearchComponent
              onSearch={() => { }}
              onFocusChange={(focus) =>
                setShowCategories(focus || showCategories)
              }
            />
          </div>
        </div>

      </div>

      {globalState.duplicatePost && (
        <div className="duplicate-modal-overlay">
          <div className="duplicate-modal-content">
            <button
              className="duplicate-modal-close"
              onClick={() => setDuplicatePost(null)}
            >
              &times;
            </button>
            {globalState.duplicatePost.post_status === 9 ? (
              <span
                style={{
                  display: "block",
                  margin: "20px auto 20px auto",
                  color: "red",
                  textAlign: "center",
                }}
              >
                This topic was previously posted and has been deemed
                inappropriate.
              </span>
            ) : (
              <>
                <span
                  style={{
                    display: "block",
                    margin: "5px auto 10px auto",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  Post already exists. Check it out!
                </span>
                <Post
                  key={globalState.duplicatePost.uuid}
                  post={globalState.duplicatePost}
                  pageName="duplicate"
                />
              </>
            )}
          </div>
        </div>
      )}

    </>
  );
}

export default Header;
